import { PipeTransform } from '@angular/core';
import moment from 'moment-timezone';
var TimezoneDatePipe = /** @class */ (function () {
    function TimezoneDatePipe() {
    }
    TimezoneDatePipe.prototype.transform = function (date, time, timezone) {
        if (!date) {
            return;
        }
        var dateTime = date + " " + (time || '00:00');
        if (!timezone || !time) {
            return this.format(dateTime, !!time);
        }
        var dateTimeWithLocalUTC = moment.tz(dateTime, timezone).local();
        return this.format(dateTimeWithLocalUTC, true);
    };
    TimezoneDatePipe.prototype.format = function (dateTime, hasTime) {
        var formatRule = hasTime ? 'DD/MM/yyyy HH:mm' : 'DD/MM/yyyy';
        return moment(dateTime).format(formatRule);
    };
    return TimezoneDatePipe;
}());
export { TimezoneDatePipe };
